export default __webpack_public_path__ + "static/media/makah.a544a13d.mp4";